var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.focus.noninteractive.ds500",
      modifiers: {
        "hover": true,
        "focus": true,
        "noninteractive": true,
        "ds500": true
      }
    }],
    staticClass: "item-container",
    class: {
      'is-current': _vm.isCurrent
    },
    attrs: {
      "type": "button",
      "aria-current": _vm.isCurrent ? 'true' : null,
      "title": _vm.name
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('update-current', _vm.companyId);
      }
    }
  }, [_c('div', {
    staticClass: "rounded-circle company-picture-container",
    class: {
      'current-company': _vm.isCurrent
    }
  }, [_vm.photoUrl ? _c('div', [_c('img', {
    staticClass: "rounded-circle d-block",
    attrs: {
      "width": "32px",
      "height": "32px",
      "src": _vm.photoUrl,
      "alt": ""
    }
  })]) : _c('div', {
    staticClass: "company-circle rounded-circle d-flex align-items-center justify-content-center",
    class: {
      'is-demo': _vm.isDemo
    }
  }, [_vm._v(" " + _vm._s(_vm.companyInitials) + " ")])]), _c('span', {
    staticClass: "company-name"
  }, [_vm._v(_vm._s(_vm.name))]), _vm.isCurrent ? _c('span', {
    staticClass: "current-indicator"
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("✓")]), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v(_vm._s(_vm.$t('companies.statuses.current')))])]) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };